import http from '../utils/request'

/** 快捷入口接口 — 对应后端 QuickLinkController (/api/quicklink) */

/** 获取当前用户的快捷入口 */
export const getMyQuickLinks = () => http.get('/quicklink/mine')

/** 获取可用模块列表（供新增选择） */
export const getAvailableModules = () => http.get('/quicklink/modules')

/** 获取可用流程列表（供新增选择） */
export const getAvailableProcesses = () => http.get('/quicklink/processes')

/** 新增快捷入口 */
export const createQuickLink = (data) => http.post('/quicklink', data)

/** 更新排序 */
export const updateQuickLinkOrder = (guid, sortOrder) =>
  http.put(`/quicklink/${guid}/order`, { sortOrder })

/** 删除快捷入口 */
export const deleteQuickLink = (guid) => http.delete(`/quicklink/${guid}`)
